export default __webpack_public_path__ + "static/media/6296f8e927ac3de911879d6c90a5c733.png";